export const get_unit_orders = `query get_unit_orders($paginator: Paginator!, $order: ListingOrder!, $filter: ListingFilter!){
    get_unit_orders(paginator: $paginator, order: $order, filter: $filter){
        unit_orders{
            transaction_code
            status
            direction
            security{
                short_name
                name
                stock_market_locality
                currency{
                    currency
                    name
                    decimal
                }
            }
            count
            fulfilled_count
            validity_start
            validity_end
            deal_price
            purchase_value
        }
        page
        page_count
    }
}`;
